const ENV = {
  API_BASE_URL: process.env.REACT_APP_API_BASE,
  USER_SERVICE_URL: process.env.REACT_APP_USER_SERVICE_URL,
  BILLING_SERVICE_URL: process.env.REACT_APP_BILLING_SERVICE_URL,
  MESSAGING_SERVICE_URL: process.env.REACT_APP_MESSAGING_SERVICE_URL,
  COMMAN_SERVICES_URL: process.env.REACT_APP_COMMAN_SERVICES_URL,
  COMPANY_SERVICE_URL: process.env.REACT_APP_COMPANY_SERVICE_URL,
  CANDIDATE_SERVICE_URL: process.env.REACT_APP_CANDIDATE_SERVICE_URL,
};

export default ENV;
